module.exports = __webpack_public_path__ + "img/pr-15.790f4bfc.png";